import type { Events } from "@/types/eventBus";
import mitt from "mitt";


export const eventBus = mitt<Events>();
